export interface SearchResponse<T> {
    totalSize: number,
    allData: T[],
    results: T[]
}
export const isSearchResponse = (entity: any) => {
    return entity 
        && typeof entity === 'object'
        && !Array.isArray(entity) 
        && entity.hasOwnProperty('totalSize') 
        && entity.hasOwnProperty('allData')
        && entity.hasOwnProperty('results')
        && Array.isArray(entity.allData)
        && Array.isArray(entity.results) || entity.results === null
        && Number.isInteger(entity.totalSize) 
}